import React from 'react';
import SIcon from './SIcon';
import { faDoorClosed } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faDoorClosed} fa />;

export default Icon;
